/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */
"use strict";

function assignProperty (object, key, value) {
	if (typeof object === "object") {
		object[key] = value;
	}

	return object;
}

module.exports = assignProperty;



//////////////////
// WEBPACK FOOTER
// ./~/react-transmit/src/lib/assignProperty.js
// module id = 810
// module chunks = 0